/** New album order after dropping `draggedIds` before/after `targetId`; dragged ids keep their relative album order. */
export function moveIds(ids: string[], draggedIds: string[], targetId: string, before: boolean): string[] {
  if (ids.indexOf(targetId) < 0 || draggedIds.indexOf(targetId) >= 0) return ids
  const moving = ids.filter((id) => draggedIds.indexOf(id) >= 0)
  if (moving.length === 0) return ids
  const rest = ids.filter((id) => draggedIds.indexOf(id) < 0)
  const at = rest.indexOf(targetId) + (before ? 0 : 1)
  return rest.slice(0, at).concat(moving, rest.slice(at))
}
